import SalesSummaryYearly from "../components/salessummaryyearly";

const SalesSummaryYearlyPage = () => {
    return (<>
        <SalesSummaryYearly />
    </>)
}

export default SalesSummaryYearlyPage;